<template>
  <IuiSpaceLock
    :value="value"
    :disabled="isDisabled"
    :orientation="orientation"
    @click="isDisabled ? null : update(prop, !value)"
  />
</template>

<script>
import inspectorInput from "@/mixins/inspector-input";
import {IuiSpaceLock} from "inspector-ui"

export default {
  components: {
    IuiSpaceLock
  },
  mixins: [inspectorInput],
  props: {
    orientation: {
      type: String,
      required: true
    }
  }
};
</script>

